import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import './InputMisc.module.scss';
import Select from 'react-select';
import customIsoString from 'utilities/custom-iso-string';
import { colourStyles } from 'utilities/colored-select-circle.js';

/**
 * Import components
 */
import Card from 'components/UI/Card/Card';
import DropDown from 'components/UI/DropDown/DropDown';
import Checkbox from 'components/UI/Checkbox/Checkbox';
import Button from 'components/UI/Button/Button';
import Subject from 'components/UI/Subject/Subject';

/**
 * Import FontAwesome
 */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import storeTask from 'actions/task/store';

const timeOptionArray = [ 5, 10, 15, 20, 25, 30, 40, 50, 60, 75, 90, 120, 150, 180 ];


const mapDispatchToProps = {
    storeTask
};

const mapStateToProps = (state, props) => {
    return {
        user: state.authentication.user,
        tasks: state.task.entities
    };
};

const valueFromId = (opts, id) => opts.find(o => o.value === id);
const months = [ 'januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december' ];

const customStyles = {
    control: styles => ({ 
        ...styles, 
        fontSize: '12px',
    }),
    option: styles => ({
        ...styles,
        fontSize: '12px',
    })
};

class InputMisc extends Component {

    constructor() {
        super();

        this.state = {
            name: '',
            note: '',
            time: 10,
            status: 'not_started',
            order: 99,
            image: null,
            typeTask: 'overige',
        };

        this.handleNameUpdate   = this.handleNameUpdate.bind(this);
        this.handleNoteUpdate   = this.handleNoteUpdate.bind(this);
        this.handleTimeUpdate   = this.handleTimeUpdate.bind(this);
        this.deleteImage        = this.deleteImage.bind(this);
        this.onImageChange      = this.onImageChange.bind(this);
        this.openImage          = this.openImage.bind(this);
        this.storeTask          = this.storeTask.bind(this);
        this.handleTypeTaskUpdate = this.handleTypeTaskUpdate.bind(this);
        
    }

    static getDerivedStateFromProps(props, state) {
        if (props.date != state.date) {
            return {
                date: props.date
            };
        }
        return null;
    }

    handleNameUpdate(event) {
        this.setState({ name: event.target.value });
    }

    handleNoteUpdate(event) {
        this.setState({ note: event.target.value });
    }

    handleTimeUpdate(event) {
        this.setState({ time: event.target.value });
    }
    handleTypeTaskUpdate(event) {
        this.setState({ typeTask: event.target.value });
    }

    onImageChange(e) {
        const files = Array.from(e.target.files);
        if (files.length < 1) {
            return;
        }

        const image = files[0];
        let reader = new FileReader();

        reader.onloadend = () => {
            this.setState({
                imagePreviewUrl: reader.result,
                image: image
            });
        };
      
        reader.readAsDataURL(image);
    }

    deleteImage() {
        this.setState({
            imagePreviewUrl: null,
            image: null
        });

    }

    storeTask() {

        let date = this.state.date;
        let tasksForToday = this.props.tasks.allIds.map((taskId) => this.props.tasks.byId[taskId]);
        tasksForToday = tasksForToday.filter((task) => task.date == date).sort((a, b) => a.order - b.order);
        
        let order = 0;
        if (tasksForToday.length > 0) {
            let lastTask = tasksForToday[tasksForToday.length - 1];
            order = (lastTask.order + 1);
        }

        this.props.storeTask({
            ...this.state,
            order: order,
            date: date,
            name: this.state.typeTask == 'pauze' ? 'plenda_pauze' : this.state.name,
        })
            .then((result) => this.props.handleClose())
            .catch((error) => alert('Er ging iets mis met het opslaan van de taak'));
    }

    openImage(data) {
        var image = new Image();
        image.src = data;
        var w = window.open('');
        w.document.write(image.outerHTML);
    }

    render() {

        let timeOptions = [];

        if (this.props.user && this.props.user.use_timer) {
            for (let index = 0; index < timeOptionArray.length; index++) {
                timeOptions.push(<option key={index} value={timeOptionArray[index]}>{timeOptionArray[index]} min</option>);   
            }

        } else {
            timeOptions.push(<option key={1} value={10}>-</option>);
        }

        return (
            <div styleName="input-content">
                <h1 styleName="title">Taak invoeren</h1>
                <div styleName='card-content'>
                    <p>Type taak</p>
                    <DropDown borderRadius='5px' type='dark' lightborder width='100%' style={{ borderRadius: '5px' }}>
                        <select value={this.state.typeTask} onChange={this.handleTypeTaskUpdate}>
                            <option value='overige'>Overige taak</option>
                            <option value='pauze'>Pauze</option>
                        </select>
                    </DropDown>
                    {this.state.typeTask == 'overige' &&
                        <Fragment>
                            <p>Beschrijving (max 50 tekens)*</p>
                            <input styleName='input description'  type='text' value={this.state.name} onChange={this.handleNameUpdate} placeholder='Bijvoorbeeld par 1,2,3' />
                        </Fragment>
                    }
                    <p>Tijdsindicatie*</p>
                    <DropDown type='dark' lightborder width='100%' borderRadius='5px'>
                        <select value={this.state.time} onChange={this.handleTimeUpdate}>
                            {timeOptions}
                        </select>
                    </DropDown>
                    {this.state.typeTask == 'overige' &&
                        <Fragment>
                            <p>Notitie</p>
                            {/* <div styleName="note-background" >
                                <input styleName='note' type='text' placeholder='Notitie' value={this.state.note} onChange={this.handleNoteUpdate}/>
                                
                                <label htmlFor='single'>
                                    <FontAwesomeIcon style={{ margin: '10px 10px 0 0', cursor: 'pointer' }} icon={[ 'fas','camera' ]}/>
                                </label>
                                <input type='file' id='single' onChange={this.onImageChange} /> 
                            </div> */}
                            <div styleName="note-background">
                                <textarea styleName='note' type='text' placeholder='Notitie' value={this.state.note} onChange={this.handleNoteUpdate} />
                                <label htmlFor='single'>
                                    <FontAwesomeIcon style={{ margin: '10px 10px 0 0', cursor: 'pointer' }} icon={[ 'fas','camera' ]}/>
                                </label>
                                <input type='file' id='single' onChange={this.onImageChange} />
                            </div>
                        </Fragment>
                    }
                    {
                        this.state.imagePreviewUrl && 
                        <div styleName='image'>
                            <FontAwesomeIcon onClick={this.deleteImage} styleName='delete' icon={[ 'far','times' ]}/>
                            <Button title='bijlage bekijken' normal style={{ background: 'rgba(255, 255, 255, 0.1)', color: '#fff', borderRadius: '3px', height: '36px', width: '224px' }} icon={[ 'fal','paperclip' ]} smallIcon handleClick={() => this.openImage(this.state.imagePreviewUrl)}/>
                        </div>
                    }
                    <div styleName='buttons' >
                        <p onClick={this.handleClose}>Annuleer</p>
                        <p onClick={this.storeTask} style={{ color: '#0088fe' }}>Opslaan</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InputMisc);